module.exports = __webpack_public_path__ + "static/media/default-event.9147eafd.jpg";